import { useSearchParams } from 'react-router-dom'
import { clsx } from 'clsx'

import CustomerInquiriesTab from './tabs/CustomerInquiriesTab'
import BriefingApplicationsTab from './tabs/BriefingApplicationsTab'
import BriefingSessionsTab from './tabs/BriefingSessionsTab'
import FranchiseInquiriesTab from './tabs/FranchiseInquiriesTab'
import LcCenterInquiriesTab from './tabs/LcCenterInquiriesTab'

type TabKey = 'customer' | 'briefing-sessions' | 'briefing' | 'franchise' | 'lc-center'

const TABS: { key: TabKey; label: string }[] = [
  { key: 'customer', label: '고객 문의' },
  { key: 'briefing-sessions', label: '사업설명회 회차' },
  { key: 'briefing', label: '사업설명회 신청' },
  { key: 'franchise', label: '가맹 문의' },
  { key: 'lc-center', label: 'LC 센터 문의' },
]

const isTabKey = (v: string | null): v is TabKey =>
  v === 'customer' || v === 'briefing-sessions' || v === 'briefing' || v === 'franchise' || v === 'lc-center'

export default function SupportInquiryPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab: TabKey = isTabKey(tabParam) ? tabParam : 'customer'

  const setTab = (next: TabKey) => {
    const sp = new URLSearchParams(searchParams)
    sp.set('tab', next)
    setSearchParams(sp, { replace: true })
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="border-b border-border">
        <nav className="-mb-px flex gap-2" aria-label="문의 관리 탭">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setTab(tab.key)}
              className={clsx(
                'border-b-2 px-4 py-2 text-sm font-medium transition-colors',
                activeTab === tab.key
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
              )}
              aria-current={activeTab === tab.key ? 'page' : undefined}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'customer' && <CustomerInquiriesTab />}
      {activeTab === 'briefing-sessions' && <BriefingSessionsTab />}
      {activeTab === 'briefing' && <BriefingApplicationsTab />}
      {activeTab === 'franchise' && <FranchiseInquiriesTab />}
      {activeTab === 'lc-center' && <LcCenterInquiriesTab />}
    </div>
  )
}
